export default __webpack_public_path__ + "static/media/searchClose.21ded5df.svg";